<script>
import { Image, Row, Col } from 'vant'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-staff-invite',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-image': Image,
        'van-row': Row,
        'van-col': Col,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            staff: {
                organizationName: null,
                organizationLogoUrl: null,
                role: null,
                roleLabel: null,
                organizationEntyYear: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // component computed
    //--------------------------------------------------
    computed: {
        entryYear() {
            if (this.locale.localeProp) {
                return this.locale.localeProp('staff-entry-year', {year: this.staff.organizationEntyYear})
            }
            return ''
        },
        inviteStaff() {
            if (this.locale.localeProp) {
                return this.locale.localeProp('invite-staff-as-role', {role: this.staff.roleLabel})
            }
            return ''
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onJoinBtnClick: function() {
            this.$emit('custom-event', {
                type: 'join'
            })
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <div class="staff-invite">
        <div class="head text-center">
            <div class="org-logo">
                <van-image 
                    :src="adjustImageSize(staff.organizationLogoUrl, 124, 124)" 
                    fit="cover" 
                    round
                    width="62px" 
                    height="62px"
                />
            </div>
            <div class="org-name">
                <span class="label main-title">{{ staff.organizationName }}</span>
            </div>
        </div>
        <div class="body bg-white text-center">
            <div class="invite-title"><span class="minor-title">{{ inviteStaff }}</span></div>
            <div @click="onJoinBtnClick" class="join-btn vertical-center justify-center"><span class="text-title color-white">{{ locale['join-us'] }}</span></div>
            <div class="feature">
                <van-row class="line minor-text prompt-color" type="flex" justify="center">
                    <van-col span="4">
                        <div class="title">
                            <div class="label block">{{ locale['match-signup-top'] }}</div>
                            <div class="label block">{{ locale['match-signup-bottom'] }}</div>
                        </div>
                        <div class="icon">
                            <img src="@/assets/org/match-signup-symbol.svg"/>
                        </div>
                    </van-col>
                    <van-col span="4">
                        <div class="title">
                            <div class="label block">{{ locale['team-registration-top'] }}</div>
                            <div class="label block">{{ locale['team-registration-bottom'] }}</div>
                        </div>
                        <div class="icon">
                            <img src="@/assets/org/team-registration-symbol.svg"/>
                        </div>
                    </van-col>
                    <van-col span="4">
                        <div class="title">
                            <div class="label block">{{ locale['match-schedule-top'] }}</div>
                            <div class="label block">{{ locale['match-schedule-bottom'] }}</div>
                        </div>
                        <div class="icon">
                            <img src="@/assets/org/match-schedule-symbol.svg"/>
                        </div>
                    </van-col>
                    <van-col span="4">
                        <div class="title">
                            <div class="label block">{{ locale['match-notification-top'] }}</div>
                            <div class="label block">{{ locale['match-notification-bottom'] }}</div>
                        </div>
                        <div class="icon">
                            <img src="@/assets/org/match-notification-symbol.svg"/>
                        </div>
                    </van-col>
                    <van-col span="4">
                        <div class="title">
                            <div class="label block">{{ locale['live-broadcast-top'] }}</div>
                            <div class="label block">{{ locale['live-broadcast-bottom'] }}</div>
                        </div>
                        <div class="icon">
                            <img src="@/assets/org/live-broadcast-symbol.svg"/>
                        </div>
                    </van-col>
                    <van-col span="4">
                        <div class="title">
                            <div class="label block">{{ locale['sports-insurance-top'] }}</div>
                            <div class="label block">{{ locale['sports-insurance-bottom'] }}</div>
                        </div>
                        <div class="icon">
                            <img src="@/assets/org/sports-insurance-symbol.svg"/>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </div>
    </div>
</template>

<style scoped>
.head {
    height: 198px;
}
.org-logo {
    padding-top: 40px;
}
.org-name {
    margin-top: 19px;
}
.body {
    height: calc(100vh - 198px);
}
.invite-title {
    padding-top: 51px;
}
.join-btn {
    margin-top: 27px;
    margin-bottom: 53px;
    width: 303px;
    height: 50px;
    border-radius: 55px;
    background: #4AA2F7;
    margin-left: 36px;
}
.feature .line {
    padding-left: 20px; 
    padding-right: 20px;
}
.feature .title {
    width: 30px;
    height: 30px;
    padding-left: 13px;
    margin-bottom: 9px;
}
</style>